module.exports = __webpack_public_path__ + "static/media/Tube.3232cea6.svg";